<template>
  <div class="row">
    <div class="col-md-6">
      <b-card :header="displayName">
        {{displayName}}
        <span slot="footer">Go to <!-- <router-link class="font-weight-bold" :to="'/companies/' + detailedInfo.id"> -->profile<!-- </router-link> --> page</span>
      </b-card>
      <b-card header="Partnership" v-if="partnerInfo">
        <!-- <span>{{partnerInfo.name}} - {{ partnerInfo.id }}</span> -->
        <ul class="mb-1 partner--list">
          <li
            v-for="partner in partnerInfo"
            :key="partner.key">
              <i class="fa fa-check-square"></i>
                {{partner.id}} - {{partner.name}}
          </li>
        </ul>
      </b-card>
      <card-list-info header="Address" :items="addressInfo"></card-list-info>
      <!-- <card-list-info header="Profile" :items="userInfoList"></card-list-info>
      <card-list-info header="Account" :items="accountInfo"></card-list-info> -->
      <b-card header="Ownership" v-if="ownerInfo">
        <span><a href="" @click.prevent="gotoOwnership()">{{ownerInfo.name}}</a></span>
      </b-card>
    </div>
    <div class="col-md-6">
      <b-card
        v-if="canIDeleteCompany(detailedInfo)"
        header-bg-variant="warning" border-variant="warning" header="Disable this company">
        <p>Blocking companies has the following effects: </p>
        <ul class="pl-4">
          <li>Users will not be able to login</li>
          <li>Partnership will be supended.</li>
        </ul>
        <b-button variant="warning">Disable</b-button>
      </b-card>
      <b-card
        v-if="canIDeleteCompany(detailedInfo)"
        header-bg-variant="danger" border-variant="danger" header="Remove this company">
        <p>Removing companies has the following effects: </p>
        <ul class="pl-4">
          <li>Users within the company will be removed</li>
          <li>Vehicles within the company will be removed</li>
          <li>Shipment will be stopped and archived</li>
        </ul>
        <b-button v-b-modal.delete_company variant="danger">Remove</b-button>
      </b-card>
    </div>
    <div>
      <b-modal
        id="delete_company"
        title="Delete Company"
        header-bg-variant="danger"
        ok-variant="danger"
        @ok="deleteCompany()">
        <p class="my-4">Are you sure want to delete this company ?</p>
      </b-modal>
    </div>
  </div>
</template>
<script>
import companyMixin from '@/mixins/company';
import CardListInfo from '@/components/CardListInfo';
import { get, isEmpty } from 'lodash';

export default {
  mixins: [companyMixin],
  components: {
    CardListInfo,
  },
  created() {
    this.$store.dispatch('companies/LOAD_DETAIL_DATA');
  },
  computed: {
    displayName() {
      return this.detailedInfo.name || '';
    },
    detailedInfo() {
      return this.$store.getters['companies/get_detail_data'];
    },
    ownerInfo() {
      return this.detailedInfo.parent;
    },
    partnerInfo() {
      const sapData = get(this.detailedInfo, 'metadata.sapData') || {};
      const id = get(this.detailedInfo, 'metadata.partnerId');
      const names = ['NAME1', 'NAME2', 'NAME3'];
      const partners = [];
      const pushedNames = [];

      names.forEach((key) => {
        const name = get(sapData, key);
        if (!isEmpty(name) && !pushedNames.includes(name)) {
          partners.push({ name, key, id });
          pushedNames.push(name);
        }
      });

      if (isEmpty(partners)) {
        return false;
      }
      return partners;
    },
    addressInfo() {
      let { address } = this.detailedInfo;
      address = address || {};

      const infoList = [
        { key: 'country', label: 'Country', value: address.country },
        { key: 'state', label: 'State', value: address.state },
        { key: 'city', label: 'City', value: address.city },
        { key: 'address1', label: 'Address 1', value: address.address1 },
        { key: 'address2', label: 'Address 2', value: address.address2 },
        { key: 'zip_code', label: 'Zip Code', value: address.zip_code },
        // { key: 'latitude', label: 'latitude', value: address.latitude },
        // { key: 'longitude', label: 'longitude', value: address.longitude },
      ];

      return infoList;
    },
  },
  methods: {
    deleteCompany() {
      this.$store.dispatch('companies/DELETE_DATA').then((ok) => {
        if (ok) this.$router.push('/admin/companies');
      });
    },
    gotoOwnership() {
      const { id } = this.ownerInfo;
      this.$router.push(`/admin/companies/${id}`);
    },
  },
};
</script>

<style lang="sass" scoped>
.partner--list
  list-style: none;
  margin: 0px;
  padding: 0px;
  padding-left: 5px;
</style>



// WEBPACK FOOTER //
// src/views/pages/admin/companies/detail/Preview.vue